var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ModalFormFormat } from "../../UI/FormFormat/FormFormat";
import DuplicatePersonService from "../../../Services/DuplicatePerson.service";
const DuplicateIgnoreModal = (_a) => {
    var { duplicates, unCheckEverything } = _a, modalProps = __rest(_a, ["duplicates", "unCheckEverything"]);
    const duplicatesIds = duplicates.map((duplicate) => duplicate.id);
    const editIgnoreRequest = {
        ignore: true,
        duplicatePersonIds: duplicatesIds,
    };
    return (_jsx(ModalFormFormat, Object.assign({}, modalProps, { modalTitle: "Ignore Duplicates", handleSubmit: () => DuplicatePersonService.editIgnore(editIgnoreRequest).then(() => {
            unCheckEverything();
        }), saveButtonContents: "Confirm", children: _jsx("div", { className: "form-group", children: _jsxs("div", { children: ["Are you sure you want to ignore ", duplicatesIds.length, " selected", " ", duplicatesIds.length > 1 ? "duplicates" : "duplicate", "? Ignoring a duplicate will cause it to show in the Ignored tab for all current and future Rule Sets that detect it."] }) }) })));
};
export default DuplicateIgnoreModal;
